// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".design[data-v-420f86c5]{width:904px;height:464px;padding:30px;box-sizing:border-box;background-color:#fff;border-radius:4px}.design-title[data-v-420f86c5]{margin:0;text-align:left;font-family:PingFang SC;font-weight:700;font-size:28px}.design-content[data-v-420f86c5]{display:flex}", ""]);
// Exports
module.exports = exports;
